import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { UserService } from "@main/users";
import { UserHelperService } from "@main/users/user-helper.service";
import { EpisodeSelectControlComponent } from "@project/episode/episode-select/episode-select-control.component";
import { EpisodeSelectMode } from "@project/episode/episode-select/episode-select-mode";
import { EpisodeSelectOption } from "@project/episode/episode-select/episode-select-option";
import { IEpisode } from "@project/models/episodes/episode";
import { EpisodeCreatedFrom } from "@project/models/episodes/episode_createdFrom";

@Component({
    selector: "formio-select-episode-dialog",
    templateUrl: "./formio-select-episode-dialog.component.html"
})

export class FormIOEpisodeSelectDialogComponent implements OnInit {
    @Output() readonly onSkip = new EventEmitter<IEpisode>();
    @Output() readonly onCancel = new EventEmitter();
    @Output() readonly onSelect = new EventEmitter<IEpisode>();
    @Output() readonly viewEpisode = new EventEmitter();

    @Input() episode: IEpisode = null;
    @Input() episodeId: string = null;


    @Input() episodeRequired: boolean = false;
    @Input() restoreSelectControlState = false;
    @Input() restoreSelectedEpisode: IEpisode = null;
    @Input() restoreDuplicateCheakState = false;
    @Input() patientId: string = null;
    @Input() surveyInstance: boolean = false;
    @Input() episodeSelectLocked: boolean = false;
    @Input() episodeSelectDialogVisible: boolean = true;

    @ViewChild(EpisodeSelectControlComponent, { static: false })
    episodeSelectControlComponent: EpisodeSelectControlComponent;

    restoreSelectDialog: boolean = true;

    createFrom: EpisodeCreatedFrom = EpisodeCreatedFrom.Form;

    episodeSelectOption: EpisodeSelectOption;

    selectionModes: EpisodeSelectMode[] = [
        EpisodeSelectMode.ExistingEpisode,
        EpisodeSelectMode.NewEpisode
    ];


    offlineInvalidModes: EpisodeSelectMode[] = [
        EpisodeSelectMode.ExistingEpisode,
        EpisodeSelectMode.NewEpisode,
        EpisodeSelectMode.EditEpisode
    ]

    isWalkInDraft = false;
    isPrescription = false;


    onEpisodeChange(value: EpisodeSelectOption) {
        if (value) {
            this.episode = value.episode;
        } else {
            this.episode = null
        }
        this.onSelect.emit(this.episode);
    }


    assignedClinicianId: string = null;

    constructor(
        private userHelperService: UserHelperService,
        private userService: UserService
    ) {
        this.assignedClinicianId = this.userHelperService.userId;
    }

    resetEpisodeSelectOption(){
      this.episode = this.episode.id=null;
  
       if (this.episodeSelectControlComponent) {
           this.episodeSelectControlComponent.onSelectEpisodeModeChange(null);
       }
    }

    ngOnInit(): void {
        if (this.episode) {
            this.episodeSelectOption = {
                episode: this.episode,
                selectMode: EpisodeSelectMode.ExistingEpisode
            };

            if (this.userHelperService.isPatient) {
                this.selectionModes = [EpisodeSelectMode.ExistingEpisode];
            } else {
                this.selectionModes.push(EpisodeSelectMode.EditEpisode);
            }
        }

        if (this.restoreDuplicateCheakState) {
            this.episodeSelectOption = <EpisodeSelectOption>{
                episode: null,
                selectMode: EpisodeSelectMode.NewEpisode,
            };
        }

        if (this.restoreSelectControlState && this.restoreSelectedEpisode) {
            this.restoreSelectDialog = false;
            this.episode = this.restoreSelectedEpisode;

            this.episodeSelectOption = {
                episode: this.restoreSelectedEpisode,
                selectMode: EpisodeSelectMode.ExistingEpisode
            };

            this.episodeSelectDialogVisible = true;
        } else if (this.restoreSelectControlState) {
            this.episodeSelectOption = {
                episode: this.restoreSelectedEpisode,
                selectMode: null
            };

            this.episodeSelectDialogVisible = true;
        }

        if (this.userHelperService.isPatient) {
            this.selectionModes = [EpisodeSelectMode.ExistingEpisode];
        }

    }

}
